import React from 'react';
import { Box, ShimmerBox, Text } from '@common-fe/common-fe';

interface Props {
  children: React.ReactNode;
  headerChildren?: React.ReactNode;
  filters: React.ReactNode;
  isLoading?: boolean;
  total?: number;
  isSmallFilterMode?: boolean;
  isPreviewMode?: boolean;
  previewHeaderChildren?: React.ReactNode;
  isResultRowNode?: React.ReactNode;
}

const ReportTableWrapper: React.FC<Props> = ({
  filters,
  children,
  headerChildren,
  previewHeaderChildren,
  isLoading,
  total = 0,
  isSmallFilterMode,
  isPreviewMode,
  isResultRowNode,
}) => {
  return (
    <div>
      <Box
        margin={{ top: 'spacing12' }}
        direction="column"
        pad={{ horizontal: 'spacing24', vertical: isPreviewMode ? 'spacing24' : 'spacing12' }}
        background="module"
        round={isPreviewMode ? 'container1Round' : undefined}
      >
        <Box direction="row" align="center" justify="between">
          {isPreviewMode ? (
            <Box fill direction="row" align="center" justify="between" data-testid="report-table_result">
              <Text size="medium" weight={700}>
                Filters
              </Text>
              {previewHeaderChildren}
            </Box>
          ) : (
            <Box direction="row" justify="between">
              <Box direction="row" data-testid="report-table_result">
                <Text size="medium" weight={700} margin={{ right: 'spacing2' }}>
                  Results:
                </Text>
                {isLoading && total === 0 ? (
                  <ShimmerBox
                    data-testid="report-table_result_loading"
                    round="container2Round"
                    height="24px"
                    width="40px"
                  />
                ) : (
                  <Text data-testid="report-table_result_amount" size="medium" weight={700}>
                    {total}
                  </Text>
                )}
              </Box>
            </Box>
          )}

          {!isSmallFilterMode && !isPreviewMode && <>{headerChildren}</>}
        </Box>
        <Box direction="column" align="start" justify="start">
          <Box
            direction="row"
            align="center"
            data-testid="report-table_filters"
            fill
            margin={{ top: 'spacing8' }}
            round="container1Round"
          >
            {filters}
            {!!isSmallFilterMode && !isPreviewMode && <Box margin={{ left: 'auto' }}>{headerChildren}</Box>}
          </Box>
        </Box>
        {isPreviewMode && (
          <Box
            direction="row"
            justify="between"
            height={{ min: '40px' }}
            align="center"
            margin={{ top: 'spacing24' }}
          >
            <Text size="medium" weight={700}>
              Results preview
            </Text>
            <Box margin={{ left: 'auto' }}>{headerChildren}</Box>
          </Box>
        )}

        <Box margin={{ top: 'spacing12' }} direction="column">
          {children}
        </Box>
      </Box>
    </div>
  );
};
export default ReportTableWrapper;
